import { downloadFollowUp } from 'services/results/follow-up'
import { StrokedButton } from 'views/components/UI/Buttons'
import { ComparisonLayout } from './comparison-styled'

const show = (value: any) => (value === null || value === undefined ? 'No disponible' : String(value))
const date = (value: string | null) => (value ? value.slice(0, 10).split('-').reverse().join('/') : 'No disponible')
const delta = (value: number | null) => (value === null ? 'No disponible' : `${value > 0 ? '+' : ''}${value}`)
const head = (
  <thead>
    <tr>
      <th scope="col">Indicador</th>
      <th scope="col">Original</th>
      <th scope="col">Follow Up</th>
      <th scope="col">Cambio</th>
    </tr>
  </thead>
)

export default function BetesaComparisonContent({
  comparison,
  processId,
  busy,
  action,
}: {
  comparison: any
  processId: number
  busy: boolean
  action: (work: () => Promise<unknown>) => Promise<void>
}) {
  return (
    <ComparisonLayout>
      <h4>
        Inicial #{comparison.initial.id} frente a Follow Up #{comparison.follow_up.id}
      </h4>
      <div className="downloads">
        {(['pdf', 'excel'] as const).map((format) => (
          <StrokedButton
            key={format}
            disabled={busy}
            onClick={() =>
              action(() =>
                downloadFollowUp(
                  processId,
                  `betesa/comparison/${comparison.follow_up.id}/${format}`,
                  `Comparativo_Betesa_${comparison.initial.id}_${comparison.follow_up.id}.${
                    format === 'pdf' ? 'pdf' : 'xlsx'
                  }`
                )
              )
            }
          >
            {format === 'pdf' ? 'PDF comparativo' : 'Excel comparativo'}
          </StrokedButton>
        ))}
      </div>
      <div className="measurements">
        <div className="measurement">
          <strong>Medición original #{comparison.initial.id}</strong>
          <span>{date(comparison.initial.answer_date)}</span>
        </div>
        <div className="measurement current">
          <strong>Follow Up #{comparison.follow_up.id}</strong>
          <span>{date(comparison.follow_up.answer_date)}</span>
        </div>
      </div>
      <aside className="methodology" aria-label="Nota metodológica">
        <strong>Ten en cuenta al interpretar</strong>
        <p>{comparison.methodological_note}</p>
        <p>{comparison.interpretation}</p>
      </aside>
      <section className="skill" aria-label="Estructura de pensamiento Betesa">
        <h5>Estructura de pensamiento</h5>
        <div className="section">
          <h6>Resultados observados por cuadrante</h6>
          <div className="table-scroll">
            <table aria-label="Resultados por cuadrante Betesa">
              {head}
              <tbody>
                {comparison.rows.map((row: any) => (
                  <tr key={row.key}>
                    <th scope="row">{row.label}</th>
                    <td>{show(row.before)}</td>
                    <td>{show(row.after)}</td>
                    <td>
                      <span className="delta">{delta(row.change)}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="skill" aria-label="Indicadores complementarios Betesa">
        <h5>Indicadores complementarios</h5>
        <div className="section">
          <h6>Clasificaciones de cada medición</h6>
          <div className="table-scroll">
            <table aria-label="Clasificaciones Betesa">
              {head}
              <tbody>
                {comparison.classifications.map((row: any) => (
                  <tr key={row.key}>
                    <th scope="row">{row.label}</th>
                    <td>{show(row.before)}</td>
                    <td>{show(row.after)}</td>
                    <td>
                      {row.before == null || row.after == null
                        ? 'No disponible'
                        : row.before === row.after
                        ? 'Sin cambio'
                        : 'Cambió'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </ComparisonLayout>
  )
}
